import React, { useState } from "react";
import profile_image from "../../../images/user/Default_pfp.png";

/**
 * Member Name Component
 * Renders user name with profile image and truncation
 */
const UseRenderMemberName = ({ rowData }) => {
  const [showFullname, setShowFullname] = useState(false);

  const fullName = rowData.first_name
    ? `${rowData.first_name} ${rowData.last_name || ""}`.trim()
    : rowData.company_first_name
      ? `${rowData.company_first_name} ${rowData.company_last_name || ""}`.trim()
      : `${rowData.company_name} (Company)`;

  const displayName = showFullname
    ? fullName
    : fullName && fullName.length <= 21
      ? fullName
      : fullName && fullName.slice(0, 21) + "...";

  return (
    <div
      className={`member-name${showFullname ? " active" : ""}`}
      onMouseEnter={() => {
        if (fullName.length > 21) {
          setShowFullname(true);
        }
      }}
      onMouseLeave={() => setShowFullname(false)}
    >
      <img
        src={
          rowData.profile_image !== null && rowData.profile_image !== "null"
            ? `/uploads/lowProfileImage/${rowData.profile_image}`
            : profile_image
        }
        alt={fullName}
        className="member-image"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = profile_image;
        }}
      />
      <span>{displayName}</span>
    </div>
  );
};

export default UseRenderMemberName;

